/**
 * Shared Coming Soon route page — one component for every nav item.
 */
import { ComingSoon } from '@/components/ComingSoon';
import { useCopy } from '@/hooks/useCopy';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export function ComingSoonPage({
  titleKey,
  icon,
  fallback,
}: {
  titleKey: string;
  icon: string;
  fallback: string;
}) {
  const { t } = useCopy();
  const title = t(titleKey, fallback);
  useDocumentTitle(title);
  return (
    <ComingSoon
      title={title}
      icon={icon}
      description={t('common.comingSoonBody', 'The {{title}} screen is part of a later release.', {
        title,
      })}
    />
  );
}
